import { environment } from './environment';
export var environmentForEach = function (configFunc) {
    var configs = Object.values(environment);
    if (configFunc)
        configs.forEach(configFunc);
    return configs;
};
